import Link from 'next/link';
import React from 'react';
import { ChevronDown } from 'lucide-react';
import { WithTranslation } from 'react-i18next';
import { withTranslation } from 'next-i18next';
import {
  Avatar,
  AvatarImage,
  AvatarFallback,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from '@lb-classroom/ui';

interface PassedProps {
  t: any;
  handleLogout: () => void;
  avatarUrl: string;
  name: string;
}

type Props = WithTranslation & PassedProps;

const UserMenuForTutor: React.FC<Props> = (props: Props) => {
  const { t, handleLogout, avatarUrl, name } = props;

  const getInitials = (fullName: string) => {
    return fullName
      .split(' ')
      .map((n) => n[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center font-default text-medium focus:outline-none">
          <Avatar className="h-8 w-8">
            <AvatarImage src={avatarUrl} alt={name} />
            <AvatarFallback>{getInitials(name)}</AvatarFallback>
          </Avatar>
          <span className="ml-2 user-name text-default text-medium">
            {name}
          </span>
          <ChevronDown className="ml-2 text-default h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-64">
        <DropdownMenuItem className="show-sm" asChild>
          <Link href="/t/materials">{t('service.header.materials')}</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href="/t/profile/edit">{t('links.editProfile')}</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href="/t/password/edit">{t('links.changePassword')}</Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href="/s/notifications/edit">
            {t('links.notificationSettings')}
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href="/t/sync-cal">{t('links.syncCalendar')}</Link>
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleLogout}>
          {t('links.logout')}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default withTranslation('common')(UserMenuForTutor);
